export const SCSS_VARS = {
    '$breakpoint-max-1': 499,
    '$breakpoint-max-2': 799,
    '$breakpoint-max-3': 1199,
    '$breakpoint-max-4': 1699,
    '$breakpoint-max-5': 1999,
    '$breakpoint-max-6': 2399,
    '$breakpoint-max-last': 1349
};
